<template>
  <div class="inventory">
    <v-toolbar flat outlined>
      <v-container fluid>
        <v-row align="center">
          <v-col style="display: grid" class="text-left">
            <v-toolbar-title class="font-weight-bold float-left">
              Pemesanan Barang
            </v-toolbar-title>
          </v-col>

          <v-spacer></v-spacer>
          <!-- <v-btn @click="filterBtn()" text>
            <span class="text-capitalize">Filters</span>
            <v-icon>mdi-filter-variant</v-icon>
          </v-btn> -->
          <v-btn class="mr-2" color="grey" icon text>
            <v-icon @click="refresh()" :class="{ refresh: isRefresh }"
              >mdi-refresh</v-icon
            >
          </v-btn>
          <v-combobox
            style="max-width: 300px;"
            dense
            outlined
            :items="resource.itemList"
            v-model="table.search"
            :return-object="false"
            item-text="text"
            item-value="text"
            hide-details
            prepend-inner-icon="mdi-magnify"
            placeholder="Search"
            append-icon=""
            :search-input.sync="searchGood"
          ></v-combobox>
        </v-row>
      </v-container>
    </v-toolbar>
    <v-main>
      <div class="filter-menu mt-4 mx-7">
        <div style="display: flex; align-items: center; ">
          <div
            style="display: flex; align-items: start; justify-content: space-between; width: 100%;"
          >
            <div
              style="display: flex; align-items: center; column-gap: 18px;  row-gap: 18px;"
              class="mr-4"
            >
              <div style="max-width: 200px;">
                <v-autocomplete
                  dense
                  outlined
                  :items="resource.filterType"
                  v-model="filter.type"
                  :loading="isRefresh"
                  item-value="value"
                  item-text="text"
                  hide-details
                  append-icon="mdi-chevron-down"
                  placeholder="Pilih Filter"
                  @change="
                    resetFilter();
                    handleFilter();
                    table.pagination.page = 1;
                  "
                ></v-autocomplete>
              </div>

              <v-menu
                offset-y
                v-if="findFilterView(['Per Bulan', 'Rentang Bulan'])"
                :close-on-content-click="false"
                v-model="filter.startMonth.state"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    class="text-end"
                    readonly
                    v-model="filter.startMonth.text"
                    v-on="on"
                    placeholder="Bulan, tahun"
                    outlined
                    dense
                    single-line
                    required
                    hide-details
                  ></v-text-field>
                </template>
                <v-date-picker
                  type="month"
                  v-model="filter.startMonth.value"
                  @input="changeDate('startMonth')"
                ></v-date-picker>
              </v-menu>
              <div
                style="max-width: 200px;"
                v-if="findFilterView(['Per Tanggal', 'Rentang Tanggal'])"
              >
                <Datepicker
                  :date="filter.startDate"
                  showIconCalendar
                  :clickCloseContent="false"
                  :isIconDown="false"
                  @date-change="handleDatePicker('start', $event)"
                  :show="filter.startDateState"
                />
              </div>

              <span v-if="findFilterView(['Rentang Bulan', 'Rentang Tanggal'])"
                >s.d</span
              >
              <v-menu
                offset-y
                :close-on-content-click="false"
                v-model="filter.endMonth.state"
                v-if="findFilterView(['Rentang Bulan'])"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    class="text-end"
                    readonly
                    v-model="filter.endMonth.text"
                    v-on="on"
                    placeholder="Bulan, tahun"
                    outlined
                    dense
                    single-line
                    required
                    hide-details
                  ></v-text-field>
                </template>
                <v-date-picker
                  type="month"
                  v-model="filter.endMonth.value"
                  @input="changeDate('endMonth')"
                ></v-date-picker>
              </v-menu>
              <div
                style="max-width: 200px;"
                v-if="findFilterView(['Rentang Tanggal'])"
              >
                <Datepicker
                  class=""
                  :clickCloseContent="false"
                  :date="filter.endDate"
                  showIconCalendar
                  :isIconDown="false"
                  :show="filter.endDateState"
                  @date-change="handleDatePicker('end', $event)"
                />
              </div>

              <v-select
                dense
                placeholder="Pilih Tahun"
                hide-details="false"
                single-line
                :items="resource.yearItems"
                v-model="filter.year.value"
                v-if="findFilterView(['Per Tahun'])"
                outlined
                @change="
                  handleFilter();
                  table.pagination.page = 1;
                "
              />
              <v-autocomplete
                style="max-width: 200px;"
                dense
                outlined
                :items="supplierName"
                v-model="filter.supplier"
                :loading="isRefresh"
                item-text="name"
                item-value="id"
                hide-details
                append-icon="mdi-chevron-down"
                placeholder="Pilih Supplier"
                clearable
                @change="
                  table.pagination.page = 1;
                  handleFilter();
                "
              ></v-autocomplete>
              <div style="width: 200px">
                <v-select
                  hide-details="auto"
                  dense
                  placeholder="Pilih Status"
                  single-line
                  item-text="text"
                  item-value="value"
                  clearable
                  :items="[
                    { text: 'Sudah Diterima', value: 'received' },
                    { text: 'Belum Diterima', value: 'pending' },
                    { text: 'Dibatalkan', value: 'cancelled' },
                  ]"
                  v-model="filter.status"
                  outlined
                  append-icon="mdi-chevron-down"
                  @change="
                    table.pagination.page = 1;
                    handleFilter();
                  "
                />
              </div>
            </div>
            <div>
              <!-- Export -->
              <v-btn
                color="primary"
                class="mx-2 text-capitalize pa-0 px-3 h-8"
                light
                depressed
                outlined
                style="letter-spacing: 0.5px;height:40px;"
                prepend-icon="mdi-information"
                :disabled="table.dataItem.length <= 0"
                @click="exportData"
              >
                <v-icon small class="mr-1">mdi-download</v-icon>
                Export Data</v-btn
              >
            </div>
          </div>
        </div>
      </div>

      <v-container fluid>
        <div>
          <v-data-table
            class="flex-grow-1 mx-4 sticky-table"
            :headers="table.headers"
            :items="table.dataItem"
            :items-per-page="itemsPerRow"
            hide-default-footer
            single-expand
            item-key="id"
            :loading="isLoading"
          >
            <template v-slot:item="{ item, index }">
              <tr class="row-datatable" :key="index">
                <td class="text-sm-left table-data">
                  {{ (table.pagination.page - 1) * itemsPerRow + index + 1 }}
                </td>
                <td class="text-sm-left table-data">
                  {{ item.date }}
                </td>
                <td class="text-sm-left table-data">
                  {{ item.order_number }}
                </td>
                <td class="text-sm-left table-data">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <div
                        v-on="on"
                        v-bind="attrs"
                        style="width: 100px; text-overflow: ellipsis; white-space: nowrap; display: block; overflow: hidden;"
                      >
                        {{ item.supplier }}
                      </div>
                    </template>
                    {{ item.supplier }}
                  </v-tooltip>
                </td>
                <td class="text-sm-left table-data">{{ item.staffOrder }}</td>
                <td class="text-sm-left table-data" style="text-wrap: nowrap;">
                  {{ formatCurrency(item.totalPrice) }}
                </td>
                <td class="table-data">
                  <v-icon :class="{ check: item.isPrinted }">{{
                    !item.isPrinted ? 'mdi-minus' : 'mdi-check'
                  }}</v-icon>
                </td>
                <td class="text-sm-left table-data">
                  <div
                    style="display: flex; align-items: center; justify-content: center;"
                  >
                    <div :class="['badge', item.status]">
                      {{
                        item.status === 'received'
                          ? 'Sudah Diterima'
                          : item.status === 'cancelled'
                          ? 'Dibatalkan'
                          : 'Belum Diterima'
                      }}
                    </div>
                  </div>
                </td>
                <td class="text-sm-left">
                  <div
                    style="display: flex; "
                    v-if="activeUser.role[0] === 'kepala unit'"
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          text
                          v-on="on"
                          v-bind="attrs"
                          @click="onClickFooter(0, 'detail', item.id)"
                        >
                          <v-icon small>
                            mdi-eye-outline
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>Detail Pemesanan</span>
                    </v-tooltip>
                    <v-menu
                      left
                      v-model="item.toggleMenu"
                      :close-on-content-click="false"
                      offset-y
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-tooltip bottom v-on="on" v-bind="attrs">
                          <template
                            v-slot:activator="{
                              on: tooltipOn,
                              attrs: tooltipAttrs,
                            }"
                          >
                            <v-btn
                              icon
                              text
                              v-bind="{ ...attrs, ...tooltipAttrs }"
                              v-on="{ ...on, ...tooltipOn }"
                            >
                              <v-icon small>
                                mdi-dots-vertical
                              </v-icon>
                            </v-btn>
                          </template>
                          <span>Lainnya</span>
                        </v-tooltip>
                      </template>
                      <v-list>
                        <v-list-item
                          :disabled="item.status === 'cancelled'"
                          @click="printSp(item)"
                          class="dropdown"
                        >
                          <v-list-item-title>
                            <div
                              style="display: flex; align-items: center; gap: 10px;"
                            >
                              <v-icon small>mdi-printer</v-icon>
                              <span class="dropdown-item">
                                Cetak Surat Pemesanan
                              </span>
                            </div>
                          </v-list-item-title>
                        </v-list-item>
                        <v-list-item
                          @click="onCancelOrder(item)"
                          class="dropdown"
                          :disabled="item.status !== 'pending'"
                        >
                          <v-list-item-title>
                            <div
                              style="display: flex; align-items: center; gap: 10px;"
                            >
                              <v-icon small>mdi-close-circle</v-icon>
                              <span class="dropdown-item">
                                Batalkan Pemesanan
                              </span>
                            </div>
                          </v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div>
                  <div style="display: flex; " v-else>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          text
                          v-on="on"
                          v-bind="attrs"
                          @click="onClickFooter(0, 'detail', item.id)"
                        >
                          <v-icon small>
                            mdi-eye-outline
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>Detail Pemesanan</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          text
                          v-on="on"
                          v-bind="attrs"
                          @click="printSp(item)"
                          :disabled="item.status === 'cancelled'"
                        >
                          <v-icon small>
                            mdi-printer
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>Cetak Surat Pemesanan</span>
                    </v-tooltip>
                  </div>
                </td>
              </tr>
            </template>
          </v-data-table>
        </div>
      </v-container>
    </v-main>

    <v-footer color="white" class="py-0">
      <v-container fluid>
        <v-row>
          <v-pagination
            v-model="table.pagination.page"
            :length="itemPages"
            total-visible="7"
            @input="refreshAndAutoUpdate()"
          ></v-pagination>
          <v-spacer></v-spacer>

          <template>
            <v-btn
              color="primary"
              fab
              dark
              @click="onClickFooter(0, 'create')"
              width="50"
              height="50"
            >
              <v-icon dark> mdi-plus </v-icon>
            </v-btn>
            <v-dialog v-model="dialog" fullscreen persistent>
              <InputItemOrder
                v-if="selectedForm == 0"
                :mode="formType"
                @change-form="changeForm"
                @close-form="closeForm"
                :requestId="requestId"
                @print-sp="printSp"
              />
              <DetailItemOrder
                v-if="selectedForm == 1"
                @change-form="changeForm"
                @close-form="closeForm"
              />
            </v-dialog>
          </template>
        </v-row>
      </v-container>
    </v-footer>
    <Snackbar
      :show="snackbar.show"
      :color="snackbar.color"
      :text="snackbar.text"
      :close="
        () => {
          clearSnackbar();
        }
      "
    />
  </div>
</template>

<script>
import Constant from '@/const';
import InputItemOrder from './ItemOrderComponent/InputItemOrder.vue';
import DetailItemOrder from './ItemOrderComponent/DetailItemOrder.vue';
import { Snackbar } from '@/components/SharedComponent';
import Datepicker from '@/components/SharedComponent/Datepicker/Datepicker.vue';
import jwtMixin from '@/mixin/jwtMixin';
import PrintItemOrder from '@/mixin/printItemOrder';
import PrintMixin from '@/mixin/printMixin';
import Swal from 'sweetalert2';
const moment = require('moment-timezone');
const axios = require('axios');
const _ = require('lodash');

export default {
  name: 'ItemOrder',
  mixins: [jwtMixin, PrintItemOrder, PrintMixin],
  components: {
    Datepicker,
    InputItemOrder,
    DetailItemOrder,
    Snackbar,
  },
  data() {
    return {
      datePicker: false,
      isLoading: false,
      isRefresh: false,
      toggleMenu: false,
      itemLoad: false,
      searchGood: '',
      formType: 'create',
      requestId: '',
      snackbar: { show: false, text: '', color: '' },
      form: {
        id: '',
        total_price: 0,
        supplier: '',
        payment_method: '',
        ppn: 11,
        shipping_cost: 0,
        stamp_cost: 0,
        down_payment: 0,
        isDpTypePercent: false,
        down_payment_type: '',
        item: [],
        status: '',
        orderDate: moment().format('DD MMMM YYYY HH:mm') + ' WIB',
        cancelledDate: '',
        orderStaff: '',
      },
      filter: {
        status: '',
        supplier: '',
        startDate: null,
        startDateState: false,
        endDate: null,
        endDateState: false,
        type: 'Semua Waktu',
        category: '10',
        startMonth: {
          text: moment()
            .locale('id')
            .format('MMMM, YYYY'),
          value: moment().format('YYYY-MM'),
          state: false,
        },
        endMonth: {
          text: moment()
            .locale('id')
            .format('MMMM, YYYY'),
          value: moment().format('YYYY-MM'),
          state: false,
        },
        year: {
          text: '',
          value: new Date().getFullYear(),
          state: false,
        },
        yearGraph: new Date().getFullYear(),
      },
      resource: {
        filterType: [
          {
            text: 'Semua Waktu',
            value: 'Semua Waktu',
          },
          {
            text: 'Per Tanggal',
            value: 'Per Tanggal',
          },
          {
            text: 'Rentang Tanggal',
            value: 'Rentang Tanggal',
          },
          {
            text: 'Per Bulan',
            value: 'Per Bulan',
          },
          {
            text: 'Rentang Bulan',
            value: 'Rentang Bulan',
          },
          {
            text: 'Per Tahun',
            value: 'Per Tahun',
          },
        ],
        itemList: [],
        yearItems: _.range(new Date().getFullYear(), 2019, -1),
      },
      expand: false,
      dialog: false,
      filterSupplier: '',
      filterDate: '',
      date: '',
      itemPages: 0,
      editedItem: {
        noQueue: 0,
        billDate: '',
        sp: '',
        supplierName: '',
        user: '',
      },
      supplierName: [],
      show: false,
      table: {
        search: '',
        pagination: {
          descending: true,
          page: 1,
          rowsPerPage: 7,
          totalItems: null,
        },
        headers: [
          { text: 'No.', sortable: false, value: 'index' },
          { text: 'Tanggal Pemesanan', sortable: false, value: 'date' },
          { text: 'No Pemesanan', sortable: false, value: 'order_number' },
          { text: 'Nama Supplier', sortable: false, value: 'supplier' },
          { text: 'Petugas Order', sortable: false, value: 'staffOrder' },
          { text: 'Total Taksiran', sortable: false, value: 'totalPrice' },
          {
            text: 'Cetak Surat',
            sortable: false,
            value: 'isPrinted',
            align: 'center',
            class: 'text-center',
          },
          {
            text: 'Status',
            sortable: false,
            value: 'status',
            align: 'center',
            class: 'text-center',
          },
          { text: '', value: 'actions', sortable: false },
        ],
        dataItem: [],
      },
      selectedForm: null,
    };
  },
  watch: {
    'table.search'() {
      this.searchData(this);
    },
    searchGood() {
      this.searchItemData(this);
    },
    dialog(newValue) {
      if (!newValue) {
        this.selectedForm = null;
      } else {
        // Need to clear snackbar before open dialog, otherwise it will only come out once
        this.clearSnackbar();
      }
    },
    date(val) {
      if (val) {
        this.dateFormat = this.formatDate(this.date);
      } else if (val === null) {
        this.getAllSupply();
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.refreshAndAutoUpdate();
      this.getSupplier();
    });
  },
  computed: {
    activeUser() {
      return this.$store.getters.userLoggedIn;
    },
    itemsPerRow() {
      let itemRow = '';
      switch (this.$vuetify.breakpoint.name) {
        case 'xs' || 'sm' || 'md':
          itemRow = 5;
          break;
        case 'lg':
          itemRow = 7;
          break;
        case 'xl':
          itemRow = 12;
          break;
        default:
          return 5;
      }
      return itemRow;
    },
  },
  methods: {
    searchData: _.debounce(v => {
      // eslint-disable-next-line no-param-reassign
      v.table.pagination.page = 1;
      v.refreshAndAutoUpdate();
    }, 250),
    searchItemData: _.debounce(v => {
      v.getItem();
    }, 250),
    handleDateChange(updatedDate) {
      this.date = updatedDate;
      this.table.pagination.page = 1;
      this.refreshAndAutoUpdate();
    },
    handleFilter() {
      let { sDate, eDate } = this.getOutputDate();
      this.getAllSupply({ sDate, eDate });
    },
    handleDatePicker(opt, date) {
      this.table.pagination.page = 1;
      if (opt === 'start') {
        this.filter.startDate = date;
        this.filter.startDateState = false;
      }
      if (opt === 'end') {
        this.filter.endDate = date;
        this.filter.endDateState = false;
      }
      this.handleFilter();
    },
    changeDate(option) {
      this.table.pagination.page = 1;
      switch (option) {
        case 'startMonth':
          this.filter.startMonth.text = moment(
            this.filter.startMonth.value,
            'YYYY-MM',
          )
            .locale('id')
            .format('MMMM, YYYY');
          this.filter.startMonth.state = false;
          break;
        case 'endMonth':
          this.filter.endMonth.text = moment(
            this.filter.endMonth.value,
            'YYYY-MM',
          )
            .locale('id')
            .format('MMMM, YYYY');
          this.filter.endMonth.state = false;
          break;
        case 'year':
          this.filter.year.text = this.filter.value;
          this.filter.year.state = false;
          break;
      }
      this.handleFilter();
    },
    resetFilter() {
      this.filter.startDate = null;
      this.filter.endDate = null;
      this.filter.startMonth = {
        text: moment()
          .locale('id')
          .format('MMMM, YYYY'),
        value: moment().format('YYYY-MM'),
        state: false,
      };
      this.filter.endMonth = {
        text: moment()
          .locale('id')
          .format('MMMM, YYYY'),
        value: moment().format('YYYY-MM'),
        state: false,
      };
      this.filter.year = {
        text: '',
        value: new Date().getFullYear(),
        state: false,
      };
    },
    getOutputDate() {
      let sDate = '';
      let eDate = '';
      if (this.filter.type === 'Per Bulan') {
        sDate = moment(this.filter.startMonth.value, 'YYYY-MM')
          .startOf('month')
          .format('YYYY-MM-DD');
        eDate = moment(this.filter.startMonth.value, 'YYYY-MM')
          .endOf('month')
          .format('YYYY-MM-DD');
      }
      if (this.filter.type === 'Rentang Bulan') {
        sDate = moment(this.filter.startMonth.value, 'YYYY-MM')
          .startOf('month')
          .format('YYYY-MM-DD');
        eDate = moment(this.filter.endMonth.value, 'YYYY-MM')
          .endOf('month')
          .format('YYYY-MM-DD');
      }
      if (this.filter.type === 'Per Tanggal') {
        sDate = this.filter.startDate;
        eDate = this.filter.startDate;
      }
      if (this.filter.type === 'Rentang Tanggal') {
        sDate = this.filter.startDate;
        eDate = this.filter.endDate;
      }
      if (this.filter.type === 'Per Tahun') {
        sDate = moment(`${this.filter.year.value}-01-01`)
          .startOf('month')
          .format('YYYY-MM-DD');
        eDate = moment(`${this.filter.year.value}-12-31`)
          .endOf('month')
          .format('YYYY-MM-DD');
      }
      return { sDate, eDate };
    },
    refresh() {
      this.isRefresh = true;
      this.handleFilter();
    },
    onClickFooter(index, formType, reqId = '') {
      // this.changeSelectedItem(order);
      this.formType = formType;
      this.changeForm(index);
      this.requestId = reqId;
      this.dialog = true;
      this.interval = clearInterval(this.interval);
    },

    changeSelectedItem(order) {
      localStorage.setItem('order_id', order.id);
    },
    changeForm(item) {
      this.selectedForm = item;
    },

    closeForm(snackbarAction = false, snackbarInfo = null) {
      this.dialog = false;
      this.interval = setInterval(this.getAllSupply, 60000);
      this.handleFilter();

      if (snackbarAction) {
        const { color, text, show } = snackbarInfo;
        this.snackbar.color = color;
        this.snackbar.text = text;
        this.snackbar.show = show;
      }
    },

    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`;
    },

    filterBtn() {
      if (this.filter === false) {
        this.filter = true;
      } else {
        this.filter = false;
        (this.filterName = ''), (this.dateFormat = '');
        this.date = '';
      }
      this.getAllSupply();
    },

    getSupplier() {
      this.runApiCalls(() => {
        axios.get(Constant.apiUrl.concat('/master/supplier')).then(response => {
          const getSupplier = response.data.data;
          this.supplierName = getSupplier.map(supplier => {
            return {
              id: supplier._id,
              name: supplier.name,
            };
          });
        });
      });
    },
    findFilterView(options) {
      return options.includes(this.filter.type);
    },

    getAllSupply(event) {
      this.isLoading = true;
      // let sDate = moment()
      //   .startOf('month')
      //   .format('YYYY-MM-DD');
      // let eDate = moment()
      //   .endOf('month')
      //   .format('YYYY-MM-DD');
      const itemCount = this.itemsPerRow;
      this.runApiCalls(() => {
        axios
          .get(
            Constant.apiUrl.concat(
              `/supply/request?page=${
                this.table.pagination.page
              }&itemCount=${itemCount}&search=${encodeURIComponent(
                this.table.search || '',
              )}&startDate=${event?.sDate || ''}&endDate=${event?.eDate ||
                ''}&id_supplier=${this.filter.supplier ?? ''}&status=${this
                .filter.status ?? ''}`,
            ),
          )
          .then(response => {
            if (response.data.data.length === 0) {
              this.isLoading = false;
              this.table.dataItem = [];
            }
            const { data } = response.data;
            const { length: dataLength } = response.data;
            this.itemPages = Math.ceil(dataLength / itemCount);
            this.table.dataItem = data;
          })
          .catch(() => {
            this.itemPages = 0;
            this.table.dataItem = [];
          })
          .finally(() => {
            this.isLoading = false;
            this.isRefresh = false;
          });
      });
    },
    refreshAndAutoUpdate() {
      if (this.interval !== null) {
        this.interval = clearInterval(this.interval);
      }
      this.handleFilter();

      this.interval = setInterval(this.handleFilter, 60000);
    },

    async exportData() {
      this.isLoading = true;
      const { sDate, eDate } = this.getOutputDate();
      const itemCount = this.itemsPerRow;
      try {
        const res = await axios.get(
          Constant.apiUrl.concat(
            `/supply/request/export?page=${
              this.table.pagination.page
            }&itemCount=${itemCount}&startDate=${sDate}&endDate=${eDate}&id_supplier=${this
              .filter.supplier || ''}&status=${this.filter.status ??
              ''}&search=${encodeURIComponent(this.table.search || '')}`,
          ),
        );
        if (res.status === 200) {
          this.snackbar.color = '#2B9C4D';
          this.snackbar.text = 'Data berhasil di export!';
          this.snackbar.show = true;
          // this.showFillSuccess('Export Berhasil');
          this.isLoading = false;
          const { url } = res.config;
          window.open(url, '_blank');
        } else {
          this.snackbar.color = '#D32F2F';
          this.snackbar.text = 'Export data gagal, silahkan coba lagi!';
          this.snackbar.show = true;
          this.isLoading = false;
        }
      } catch (error) {
        if (error) {
          this.snackbar.color = '#D32F2F';
          this.snackbar.text = 'Export data gagal, silahkan coba lagi!';
          this.snackbar.show = true;
          this.isLoading = false;
        }
      }
    },
    printSp(item) {
      axios
        .put(
          Constant.apiUrl.concat(`/supply/request/print-status/${item.id}`),
          {
            isPrinted: true,
          },
        )
        .then(() => {
          this.refreshAndAutoUpdate();
          this.getSupplyById(item.id)
            .then(result => {
              const getDataSupply = result.data.data;
              this.form.id = item.id;
              this.form.supplier = {
                ...getDataSupply.id_supplier,
                id: getDataSupply.id_supplier._id,
              };
              this.form.payment_method = getDataSupply.payment_method;
              this.form.status = getDataSupply.status;
              this.form.orderDate = moment(getDataSupply.order_date).format(
                'DD/MM/YYYY',
              );
              this.form.item = getDataSupply.item.map(item => {
                return {
                  ...item,
                  goods: {
                    id: item.id_goods ?? item.id_drugs,
                    id_goods: item.id_goods,
                    hna: item.price,
                    displayName: item.name,
                    category: item.category,
                    name: item.name,
                    id_drugs: item.id_drugs,
                  },
                  package: {
                    name: item.package,
                    quantity: item.itemsPerPackage,
                  },
                  packageItem: [
                    {
                      name: item.package,
                      quantity: item.itemsPerPackage,
                    },
                  ],
                };
              });
              try {
                const doc = this.printItemOrder(
                  this.$store.getters.userLoggedIn.clinic,
                  {
                    ...this.form.supplier,
                    orderNumber: getDataSupply.order_number,
                    date: this.form.orderDate,
                    supplierName: { name: this.form.supplier.name },
                  },
                  this.letterData,
                  {
                    detail: this.form.item.map(arr => {
                      return { ...arr, package: arr.package.name };
                    }),
                  },
                  this.$store.getters.userLoggedIn,
                );
                this.printDocument(doc, {
                  docName: 'Surat Pemesanan Barang',
                  rmNumber: getDataSupply.order_number,
                });
              } catch (error) {
                const message = error.response;
                this.snackbar.show = true;
                this.snackbar.color = '#d32f2f';
                this.snackbar.text = message ?? 'Internal server error';
              }
            })
            .catch(err => {
              const message = err.response;
              this.snackbar.show = true;
              this.snackbar.color = '#d32f2f';
              this.snackbar.text = message ?? 'Internal server error';
            });
        })
        .catch(err => {
          const message = err.response;
          this.snackbar.show = true;
          this.snackbar.color = '#d32f2f';
          this.snackbar.text = message ?? 'Internal server error';
        });
    },
    async getSupplyById(id) {
      return axios
        .get(Constant.apiUrl.concat('/supply/request/').concat(id))
        .then(response => {
          return response;
        });
    },
    onCancelOrder(item) {
      this.$nextTick(() => {
        setTimeout(() => {
          Swal.fire({
            title: `<div style="font-family: Roboto, Serif; color: #222222; font-weight: 700; font-size: 20px; line-height: 30px;"><p>Apakah Anda yakin untuk membatalkan pemesanan?</p></div>`,
            iconHtml:
              '<span style="color: #F9A825" class="mdi mdi-alert-circle-outline"></span>',
            html: `<div style="font-family: Roboto; font-style: normal; font-weight: 400; font-size: 14px; color: #616161; line-height: 150%; text-transform: none !important;"><p>Data pemesanan <b>${item.order_number}</b> akan dibatalkan dan tidak bisa diubah kembali</div>`,
            showCancelButton: true,
            customClass: {
              confirmButton: 'button-error-blue',
              cancelButton: 'button-confirm',
            },
            confirmButtonText: 'Yakin',
            cancelButtonText: 'Batal',
          }).then(result => {
            if (result.isConfirmed) {
              this.cancelOrder(item.id).then(() => {
                this.refreshAndAutoUpdate();
              });
            } else {
              return;
            }
          });
        }, 300);
      });
    },

    async cancelOrder(id) {
      await axios
        .put(Constant.apiUrl.concat(`/supply/request/cancel/${id}`), {
          status: 'cancelled',
        })
        .then(() => {
          this.snackbar.show = true;
          this.snackbar.color = '#2B9C4D';
          this.snackbar.text = 'Pemesanan berhasil dibatalkan';
          this.refreshAndAutoUpdate();
        })
        .catch(error => {
          if (error.response) {
            const message =
              error.response.data.pesan ?? 'Internal server error';
            this.snackbar.show = true;
            this.snackbar.color = '#d32f2f';
            this.snackbar.text = message;
          } else if (error.request) {
            this.snackbar.show = true;
            this.snackbar.color = '#d32f2f';
            this.snackbar.text = 'Tidak dapat menyambung ke server';
          }
        });
    },
    getItem() {
      this.itemLoad = true;
      const keyword = this.searchGood;

      axios
        .get(
          Constant.apiUrl.concat(
            `/master/drugs/goods/all?page=1&itemCount=5&search=${encodeURIComponent(
              keyword || '',
            )}`,
          ),
        )
        .then(response => {
          const data = response.data.data;
          this.resource.itemList = data.map(v => {
            return {
              text: v.display_name_nofornas,
            };
          });
        })
        .catch(() => {
          this.resource.itemList = [];
        })
        .finally(() => (this.itemLoad = false));
    },
    formatCurrency(val) {
      return (
        'Rp ' + val.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.') + ',00'
      );
    },
    clearSnackbar() {
      this.snackbar = {
        show: false,
        color: 'success',
        text: '',
      };
    },
  },
  beforeDestroy() {
    this.interval = clearInterval(this.interval);
  },
};
</script>

<style lang="scss" scoped>
.refresh {
  animation: rotation 0.23s infinite;
}
@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  25% {
    transform: rotate(90deg);
  }
  50% {
    transform: rotate(180deg);
  }
  75% {
    transform: rotate(270deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.input {
  max-width: 30%;
}

::v-deep {
  .v-data-table .v-data-table-header {
    span {
      color: #404040;
    }
  }
}
.sticky-table ::v-deep thead th {
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: #f5f5f5;
}
.sticky-table ::v-deep .v-data-table__wrapper {
  max-height: 55vh;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 5px;
    border-radius: 5px;
    background-color: #d4d4d4;
  }
  &::-webkit-scrollbar-thumb {
    width: 5px;
    border-radius: 5px;
    background-color: rgb(123, 121, 121);
  }
}
.check {
  color: #2b9c4d;
}

.badge {
  padding: 8px;
  border-radius: 4px;
  text-align: center;
  width: fit-content;
  text-wrap: nowrap;
  &.pending {
    background: #fffbea;
    color: #e26c00;
  }

  &.received {
    background: #e7f8ec;
    color: #2b9c4d;
  }

  &.cancelled {
    background: #ffebee;
    color: #d32f2f;
  }
}

.table-data {
  padding-top: 15px !important;
  padding-bottom: 15px !important;
}

::v-deep .v-list-item .v-list-item__content {
  line-height: 1.1;
  flex: 1 0 100%;
  text-align: start !important;
}

.dropdown {
  text-align: left !important;
}
</style>
